module.exports = __webpack_public_path__ + "assets/xueshimao.f6c04ac3.svg";